module.exports = __webpack_public_path__ + "img/mobilelab_stopped.d7efd858.svg";